/**
 * Classe que cria o popup alertando
 * ao usuário que já existe uma sessão para o Service time updates.
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};

Greenmile.ServiceTimeUpdates.PopupSessionAlert = function (selector) {

    this.modalForm = null;
    var popupScope = selector + ' .popupFormContainer',
        that       = this;

    var showSearchForm = function () {

        var router     = new App.Routers.ServiceTimeUpdates(),
            messageKey = "Greenmile.ServiceTimeUpdates.sessionIsFinished";
        router.endSession(messageKey);


    };

    var showGridServiceTimeUpdates = function () {

        that.modalForm.closeModalWindow();
        App.Views.ServiceTimeUpdates.showGridToServiceTimeUpdates();

    };

    var addEventListener = function () {

        var error      = null,
            btnConfirm = null,
            btnCancel  = null;

        try {

            btnConfirm = document.querySelector(popupScope + " input[name='confirm']");

            if (btnConfirm !== null) {

                btnConfirm.removeEventListener("click", showGridServiceTimeUpdates);
                btnConfirm.addEventListener("click", showGridServiceTimeUpdates);

            }

            btnCancel = document.querySelector(popupScope + " input[name='cancel']");

            if (btnCancel !== null) {

                btnCancel.removeEventListener("click", showSearchForm);
                btnCancel.addEventListener("click", showSearchForm);

            }


        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "error on add event listener");
            error.console();
        }

    };

    var contentPopup = function () {

        var contentQuestionKey = "Greenmile.ServiceTimeUpdates.alertSessionExists",
            btnConfirmKey      = "Greenmile.ServiceTimeUpdates.btnRecoverSession",
            btnCancelKey       = "Greenmile.ServiceTimeUpdates.btnInitSession",
            sessionInfo        = Monet.Session.ServiceTimeUpdates.session,
            dateSession        = Monet.Format.Date.formatToLocale(sessionInfo.startedAt),
            popup              = document.querySelector(popupScope);

        if (popup !== null) {
            popup.innerHTML = `
                <div class="popupHeader">
                <div class="headerTitle">
                    <i class="fa fa-exclamation-circle"></i>
                    ${Monet.I18n.getResourcesByKey('PopupAlert.headerTitle')}
                </div>
                </div>
                <div class="question">
                    ${Monet.I18n.getResourcesByKey(contentQuestionKey, dateSession)}
                </div>
                <div class="confirmButtons">
                    <input type="button" name="confirm" value="${Monet.I18n.getResourcesByKey(btnConfirmKey)}"/>
                    <input type="button" name="cancel" value="${Monet.I18n.getResourcesByKey(btnCancelKey)}"/>
                </div>
            `;
        }

        $(selector + " .closeModalWindow").hide();

        addEventListener();

    };

    this.showPopup = function () {

        var callbacks,
            scopeBlock = selector + " #form_and_grid",
            options    = {
                width: 600,
                height: 170
            };

        callbacks = {
            onAfterShowModalForm: contentPopup
        };

        this.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);

        this.modalForm.showModalForm();

    };

};
